export enum UserRoleEnum {
  admin = "admin",
  manager = "manager",
  distributionManager = "distribution_manager",
}
